import React from 'react'
import { BaseContentfulEntry } from '@components/renderer'
import { ExperienceConfiguration, Experience } from '@ninetailed/experience.js-next'

export interface NinetailedLibraryRendererProps {
  structure: BaseContentfulEntry
  renderer: (structure: BaseContentfulEntry) => JSX.Element | null
  parsedExperiences: ExperienceConfiguration[]
}

export const NinetailedLibraryRenderer: React.FC<NinetailedLibraryRendererProps> = ({
  structure,
  renderer,
  parsedExperiences,
}) => {
  const componentId = structure.sys.id
  const contentTypeId = structure.sys.contentType?.sys.id

  return (
    <Experience
      key={`${contentTypeId}-${componentId}`}
      {...structure}
      id={componentId}
      component={renderer}
      experiences={parsedExperiences}
    />
  )
}
